export class EstimateModel {
}

export class Estimate {
		Id : string;
		EstimateNumber : string;
		CustomerId : number;
		Balance : number;
		EstimateTotalAmount : number;
		DepositAmount : number;
		Status : string;
		ReferenceNumber : string;
		ValidityDate : any;
		EstimateDate : any;
		Discount : number;
		Tax : number;
		IsDraft : boolean;
		Notes : string;
		TCPId : number;
		DiscountType : string;
		TaxType : string;
		PartialDueType : string;
		ShowTCP : boolean;
		LocationId : number;
		CreatedBy : number;
		CreatedDate : Date;
		UpdatedBy : number;
		UpdatedDate : Date;
		FirstName : string;
		LastName : string;
		BusinessName : string;
		LocationName : string;
		EstimateItems : EstimateItems[];
		Customer: string;
		Source: string;
		TaxExemptionType: string;
    Upcharge: number;
    UpchargeType: string;
    UpchargeName: string;
    DiscountName: string;
    TaxName: string;
    TaxableTotal: number;
    NonTaxableTotal: number;
    PartialDue: number;
    TCPIds: number[];
}

export class EstimateItems {
	public IsFreetext: boolean = false;
	public Id: number;
	public ItemId: number;
	public ItemType: string;
	public EstimateNumber: string;
	public ItemName: string;
	public Quantity: number;
	public Rate: number;
	public Amount: number;
	public ProductTaxCode: string;
}

export class UpdateEstimateDetail {
	public EstimateDetail: EstimateItems;
	public Balance: number;
	public TotalAmount: number;
	public UpdatedBy: number;
}

export class SendDownloadEstimate {
	public EstimateNumber: string;
	public CustomerName: string;
	public CustomerAddress: string;
	public CustomerEmail: string;
	public BusinessLogo: string;
	public BusinessName: string;
	public BusinessAddress: string;
	public OtherEmailRecipients: string;
}

export class EstimateWorkOrder{
	public EstimateNumber: string; 
	public GeneratedWorkOrderId: string;
	public StartDateTime: string;
	public EndDateTime: string;
	public AssignedEmployeeId : number;
  public AssignedEmployeeName: string;
	public PartialDueType: string;
	public PartialDue: number;
	public CreatedBy: number;
	public CreatedDate: string;
	public UpdatedBy: number;
	public UpdatedDate: string;
	public IsPartiallyPaid: boolean;
}

export class CustomEstimateFieldValue {
  public fieldId: number = 0;
  public id: number = 0;
  public fieldName: string = '';
  public fieldDataType: number;
  public isRequired: boolean = false;
  public userId: number;
  public fieldValue: string = '';
  public saving: any;
  public estimateNumber: string;
}


